export default "__VITE_ASSET__607d6c4a__"